// Active Support Timezones. This is the list of timezones given by BE based on ActiveSupport::TimeZone.
// We will base this as the list for identifying the user timezone, and map it to the matching offset if there is
// exact match to the time zone itself from this list.
export const AS_TIMEZONE_MAPPING = {
  'Etc/GMT+12': '-12:00',
  'Pacific/Pago_Pago': '-11:00',
  'Pacific/Midway': '-11:00',
  'Pacific/Honolulu': '-10:00',
  'America/Juneau': '-09:00',
  'America/Los_Angeles': '-08:00',
  'America/Tijuana': '-08:00',
  'America/Phoenix': '-07:00',
  'America/Chihuahua': '-07:00',
  'America/Mazatlan': '-07:00',
  'America/Denver': '-07:00',
  'America/Guatemala': '-06:00',
  'America/Chicago': '-06:00',
  'America/Mexico_City': '-06:00',
  'America/Monterrey': '-06:00',
  'America/Regina': '-06:00',
  'America/Bogota': '-05:00',
  'America/New_York': '-05:00',
  'America/Indiana/Indianapolis': '-05:00',
  'America/Lima': '-05:00',
  'America/Halifax': '-04:00',
  'America/Caracas': '-04:00',
  'America/Guyana': '-04:00',
  'America/La_Paz': '-04:00',
  'America/Puerto_Rico': '-04:00',
  'America/Santiago': '-04:00',
  'America/St_Johns': '-03:30',
  'America/Sao_Paulo': '-03:00',
  'America/Argentina/Buenos_Aires': '-03:00',
  'America/Godthab': '-03:00',
  'America/Montevideo': '-03:00',
  'Atlantic/South_Georgia': '-02:00',
  'Atlantic/Azores': '-01:00',
  'Atlantic/Cape_Verde': '-01:00',
  'Europe/London': '+00:00',
  'Europe/Lisbon': '+00:00',
  'Africa/Monrovia': '+00:00',
  'Etc/UTC': '+00:00',
  'Europe/Amsterdam': '+01:00',
  'Europe/Belgrade': '+01:00',
  'Europe/Berlin': '+01:00',
  'Europe/Zurich': '+01:00',
  'Europe/Bratislava': '+01:00',
  'Europe/Brussels': '+01:00',
  'Europe/Budapest': '+01:00',
  'Africa/Casablanca': '+01:00',
  'Europe/Copenhagen': '+01:00',
  'Europe/Dublin': '+01:00',
  'Europe/Ljubljana': '+01:00',
  'Europe/Madrid': '+01:00',
  'Europe/Paris': '+01:00',
  'Europe/Prague': '+01:00',
  'Europe/Rome': '+01:00',
  'Europe/Sarajevo': '+01:00',
  'Europe/Skopje': '+01:00',
  'Europe/Stockholm': '+01:00',
  'Europe/Vienna': '+01:00',
  'Europe/Warsaw': '+01:00',
  'Africa/Algiers': '+01:00',
  'Europe/Zagreb': '+01:00',
  'Europe/Athens': '+02:00',
  'Europe/Bucharest': '+02:00',
  'Africa/Cairo': '+02:00',
  'Africa/Harare': '+02:00',
  'Europe/Helsinki': '+02:00',
  'Asia/Jerusalem': '+02:00',
  'Europe/Kaliningrad': '+02:00',
  'Europe/Kiev': '+02:00',
  'Africa/Johannesburg': '+02:00',
  'Europe/Riga': '+02:00',
  'Europe/Sofia': '+02:00',
  'Europe/Tallinn': '+02:00',
  'Europe/Vilnius': '+02:00',
  'Asia/Baghdad': '+03:00',
  'Europe/Istanbul': '+03:00',
  'Asia/Kuwait': '+03:00',
  'Europe/Minsk': '+03:00',
  'Europe/Moscow': '+03:00',
  'Africa/Nairobi': '+03:00',
  'Asia/Riyadh': '+03:00',
  'Europe/Volgograd': '+03:00',
  'Asia/Tehran': '+03:30',
  'Asia/Muscat': '+04:00',
  'Asia/Baku': '+04:00',
  'Europe/Samara': '+04:00',
  'Asia/Tbilisi': '+04:00',
  'Asia/Yerevan': '+04:00',
  'Asia/Kabul': '+04:30',
  'Asia/Yekaterinburg': '+05:00',
  'Asia/Karachi': '+05:00',
  'Asia/Tashkent': '+05:00',
  'Asia/Kolkata': '+05:30',
  'Asia/Colombo': '+05:30',
  'Asia/Kathmandu': '+05:45',
  'Asia/Almaty': '+06:00',
  'Asia/Dhaka': '+06:00',
  'Asia/Urumqi': '+06:00',
  'Asia/Rangoon': '+06:30',
  'Asia/Bangkok': '+07:00',
  'Asia/Jakarta': '+07:00',
  'Asia/Krasnoyarsk': '+07:00',
  'Asia/Novosibirsk': '+07:00',
  'Asia/Shanghai': '+08:00',
  'Asia/Chongqing': '+08:00',
  'Asia/Hong_Kong': '+08:00',
  'Asia/Irkutsk': '+08:00',
  'Asia/Kuala_Lumpur': '+08:00',
  'Australia/Perth': '+08:00',
  'Asia/Singapore': '+08:00',
  'Asia/Taipei': '+08:00',
  'Asia/Ulaanbaatar': '+08:00',
  'Asia/Tokyo': '+09:00',
  'Asia/Seoul': '+09:00',
  'Asia/Yakutsk': '+09:00',
  'Australia/Adelaide': '+09:30',
  'Australia/Darwin': '+09:30',
  'Australia/Brisbane': '+10:00',
  'Australia/Melbourne': '+10:00',
  'Pacific/Guam': '+10:00',
  'Australia/Hobart': '+10:00',
  'Pacific/Port_Moresby': '+10:00',
  'Australia/Sydney': '+10:00',
  'Asia/Vladivostok': '+10:00',
  'Asia/Magadan': '+11:00',
  'Pacific/Noumea': '+11:00',
  'Pacific/Guadalcanal': '+11:00',
  'Asia/Srednekolymsk': '+11:00',
  'Pacific/Auckland': '+12:00',
  'Pacific/Fiji': '+12:00',
  'Asia/Kamchatka': '+12:00',
  'Pacific/Majuro': '+12:00',
  'Pacific/Chatham': '+12:45',
  'Pacific/Tongatapu': '+13:00',
  'Pacific/Apia': '+13:00',
  'Pacific/Fakaofo': '+13:00',
};

export const AS_TIMEZONES = Object?.keys(AS_TIMEZONE_MAPPING);
